import { applicationContentStore } from '~/store/application/content'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const contentStore = applicationContentStore()
  await contentStore.changeFooterDisclaimer('')
})
